
import React from 'react';
import { MetricFormatter, getTimingColor } from './MetricFormatter';

interface NetworkTabProps {
  metrics: any;
}

const NetworkTab: React.FC<NetworkTabProps> = ({ metrics }) => {
  return (
    <div className="mt-1">
      <div className="max-h-40 overflow-auto">
        {metrics.navigationTimings ? (
          <div className="space-y-1">
            <div className="flex justify-between">
              <span>DNS lookup:</span>
              <span className={getTimingColor(metrics.navigationTimings.dns)}>
                <MetricFormatter value={metrics.navigationTimings.dns} type="time" />
              </span>
            </div>
            <div className="flex justify-between">
              <span>Connection:</span>
              <span className={getTimingColor(metrics.navigationTimings.connect)}>
                <MetricFormatter value={metrics.navigationTimings.connect} type="time" />
              </span>
            </div>
            <div className="flex justify-between">
              <span>Request:</span>
              <span className={getTimingColor(metrics.navigationTimings.request)}>
                <MetricFormatter value={metrics.navigationTimings.request} type="time" />
              </span>
            </div>
            <div className="flex justify-between">
              <span>Response:</span>
              <span className={getTimingColor(metrics.navigationTimings.response)}>
                <MetricFormatter value={metrics.navigationTimings.response} type="time" />
              </span>
            </div>
            <div className="flex justify-between">
              <span>Processing:</span>
              <span className={getTimingColor(metrics.navigationTimings.processing)}>
                <MetricFormatter value={metrics.navigationTimings.processing} type="time" />
              </span>
            </div>
            <div className="flex justify-between border-t border-gray-200 dark:border-gray-700 pt-1 font-medium">
              <span>Total:</span>
              <span className={getTimingColor(metrics.loadComplete)}>
                <MetricFormatter value={metrics.loadComplete} type="time" />
              </span>
            </div>
          </div>
        ) : (
          <div className="text-gray-500">No network timing data available.</div>
        )}
      </div>
    </div>
  );
};

export default NetworkTab;
